import { render, staticRenderFns } from "./AnnounceList.vue?vue&type=template&id=7b1d754c&"
import script from "./AnnounceList.vue?vue&type=script&lang=js&"
export * from "./AnnounceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports